import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { AurFormControl } from '../models/form-control.model';
import { AurFormGroup } from '../models/form-group.model';
import { InputType } from '../models/input.type';

@Component({
    selector: 'aur-form-group',
    template: `<ng-container *ngFor="let control of controls" [ngSwitch]="control.inputType">
    <aur-hidden *ngSwitchCase="inputType.hidden" fxLayout="row" [formGroup]="formGroup" [control]="control"></aur-hidden>
    <aur-dropdown *ngSwitchCase="inputType.dropdown" fxLayout="row" [formGroup]="formGroup" [control]="control" [component]="component"></aur-dropdown>
    <aur-textarea *ngSwitchCase="inputType.textarea" fxLayout="row" [formGroup]="formGroup" [control]="control"></aur-textarea>
    <aur-string *ngSwitchCase="inputType.string" fxLayout="row" [formGroup]="formGroup" [control]="control"></aur-string>
    <aur-boolean *ngSwitchCase="inputType.boolean" fxLayout="row" [formGroup]="formGroup" [control]="control"></aur-boolean>
    <aur-number *ngSwitchCase="inputType.number" fxLayout="row" [formGroup]="formGroup" [control]="control"></aur-number>
    <aur-date *ngSwitchCase="inputType.date" fxLayout="row" [formGroup]="formGroup" [control]="control"></aur-date>
    <aur-form-group *ngSwitchCase="inputType.object" fxLayout="row" [formGroup]="control" [component]="component"></aur-form-group>
</ng-container>`
})
export class FormGroupComponent implements OnInit {

    @Input() formGroup: FormGroup;
    @Input() component: Object;

    controls = new Array<AurFormControl | AurFormGroup>();

    inputType = InputType;

    ngOnInit() {
        for (const control in this.formGroup.controls) {
            if (this.formGroup.controls.hasOwnProperty(control)) {
                this.controls.push(<AurFormControl | AurFormGroup>this.formGroup.controls[control]);
            }
        }

        this.controls = this.controls.sort((e, n) => e.key - n.key);
    }
}
